export var DuplicationStrategy;
(function (DuplicationStrategy) {
    DuplicationStrategy["KEEP_ORIGINAL"] = "KEEP_ORIGINAL";
    DuplicationStrategy["SET_WANTED"] = "SET_WANTED";
    DuplicationStrategy["MINIMIZE_DUPLICATION"] = "MINIMIZE_DUPLICATION";
})(DuplicationStrategy || (DuplicationStrategy = {}));
